<template>
  <div class="text-sm text-gray-900 dark:text-white">
    <template v-if="editable">
      <slot />
    </template>
    <template v-else>
      <p v-if="address.street">{{ address.street }}</p>
      <p v-if="address.street2">{{ address.street2 }}</p>
      <p v-if="cityStateZip">{{ cityStateZip }}</p>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

export interface AddressFields {
  street?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
}

const props = withDefaults(
  defineProps<{
    address: AddressFields;
    editable?: boolean;
  }>(),
  {
    editable: false
  }
);

const cityStateZip = computed(() => {
  const parts = [props.address.city, props.address.state].filter(Boolean);
  const line = parts.join(", ");
  return props.address.zip ? `${line} ${props.address.zip}`.trim() : line;
});
</script>
